<template>
<div>
  <div class="wistia_embed wistia_async_wv4e401e4c">
    &nbsp;
  </div>

  <div
    id="what_is_fsa"
    class="tbk-vid-embed"
  >
    <a
      id="health_care_fsa"
      class="embedded_video"
      href="#wistia_nxg3biq4dt?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="dependent_care_fsa"
      class="embedded_video"
      href="#wistia_5o7xuyj05k?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="limited_purpose_fsa"
      class="embedded_video"
      href="#wistia_ow30tcz0x8?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="replay_intro"
      class="embedded_video"
      href="#wistia_wv4e401e4c?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('wv4', 176, this.showSelect)
    this.tbk.loadCrossTime('nxg', 150, this.showSelect)
    this.tbk.loadCrossTime('5o7', 147, this.showSelect)
    this.tbk.loadCrossTime('ow3', 203, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        nxg: this.tbk.autoPlay,
        '5o7': this.tbk.autoPlay,
        ow3: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('#what_is_fsa').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#what_is_fsa
  display: none

#what_is_fsa a
  text-decoration: none

#health_care_fsa
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (42 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))

#dependent_care_fsa
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))

#limited_purpose_fsa
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (438 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))

#replay_intro
  position: absolute
  top: calc(100% * (294 / 360))
  left: calc(100% * (221 / 640))
  width: calc(100% * (195 / 640))
  height: calc(100% * (30 / 360))

</style>

